import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

interface ConfirmationDialogContext {
    title: string;
    description: string;
    buttons: { text: string; isPrimary?: boolean; onClick: () => void }[];
}

interface SuccessDialogContext {
    title: string;
    description: string;
    buttons: { text: string; isPrimary?: boolean; onClick: () => void }[];
}

interface ErrorDialogContext {
    title: string;
    description: string;
    buttons: { text: string; isPrimary?: boolean; onClick: () => void }[];
}

@Injectable({
    providedIn: 'root',
})
export class UIState {
    loadingIndicator$ = new BehaviorSubject<boolean>(false);

    dialogs$ = new BehaviorSubject<{
        confirmation: {
            isOpen: boolean;
            context?: ConfirmationDialogContext;
        };
        success: {
            isOpen: boolean;
            context?: SuccessDialogContext;
        };
        error: {
            isOpen: boolean;
            context?: ErrorDialogContext;
        };
    }>({
        confirmation: {
            isOpen: false,
        },
        success: {
            isOpen: false,
        },
        error: {
            isOpen: false,
        },
    });

    showLoadingIndicator(): void {
        this.loadingIndicator$.next(true);
    }

    hideLoadingIndicator(): void {
        this.loadingIndicator$.next(false);
    }

    openConfirmationDialog(context: ConfirmationDialogContext): void {
        if (this.dialogs$.getValue().confirmation.isOpen === false) {
            this.dialogs$.next({
                ...this.dialogs$.getValue(),
                confirmation: {
                    isOpen: true,
                    context: context,
                },
            });
        }
    }

    closeConfirmationDialog(): void {
        this.dialogs$.next({
            ...this.dialogs$.getValue(),
            confirmation: {
                isOpen: false,
            },
        });
    }

    openSuccessDialog(context: SuccessDialogContext): void {
        if (this.dialogs$.getValue().success.isOpen === false) {
            this.dialogs$.next({
                ...this.dialogs$.getValue(),
                success: {
                    isOpen: true,
                    context: context,
                },
            });
        }
    }

    closeSuccessDialog(): void {
        this.dialogs$.next({
            ...this.dialogs$.getValue(),
            success: {
                isOpen: false,
            },
        });
    }

    openErrorDialog(context: ErrorDialogContext): void {
        if (this.dialogs$.getValue().error.isOpen === false) {
            this.dialogs$.next({
                ...this.dialogs$.getValue(),
                error: {
                    isOpen: true,
                    context: context,
                },
            });
        }
    }

    closeErrorDialog(): void {
        this.dialogs$.next({
            ...this.dialogs$.getValue(),
            error: {
                isOpen: false,
            },
        });
    }
}
